import React from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import TwitterIcon from "@/assets/ic_twitter@2x.png";
import FacebookIcon from "@/assets/ic_facebook@2x.png";
import IcIcon from "@/assets/ic_ins@2x.png";
import { FormattedMessage } from "react-intl";
import "./index.css";

// https://firebase.google.com/docs/web/setup#available-libraries
import { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebaseConfig";

import italicTextLogo from "@/assets/italic_text_logo.png";

export default function () {
  // // Initialize Firebase
  useEffect(() => {
    logEvent(analytics, "page_view", { page_path: window.location.pathname });
  }, []);

  return (
    <footer className="bg-black">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-20">
          <div className="lg:flex lg:items-center lg:justify-between mb-8 lg:mb-10">
            {/* Logo */}
            <img
              src="https://api.builder.io/api/v1/image/assets/TEMP/1574b66153757d3c0b04f4d3c988ccafb7595f53?width=430"
              alt="ExtraSpace Logo"
              className="h-9 mb-6 lg:mb-0"
            />

            {/* Navigation */}
            <nav className="space-y-4 lg:space-y-0 lg:flex lg:items-center lg:gap-12">
              {[
                "首页",
                "隐私政策",
                "交易安全",
                "运输政策",
                "服务条款",
                "联系我们",
                "公告",
              ].map((link, index) => (
                <a
                  key={index}
                  href="#"
                  className="block lg:inline text-white text-base hover:text-gray-300"
                >
                  {link}
                </a>
              ))}
            </nav>
          </div>

          {/* Divider */}
          <div className="border-t border-white/20 mb-8"></div>

          {/* Copyright */}
          <p className="text-white text-base">
            © 2023 ExtraSpace. All rights reserved.
          </p>
        </div>
      </footer>
  );
}
